var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box mt-2"},[_c('button',{staticClass:"fa fa-comment-dots",on:{"click":_vm.view}})])}
var staticRenderFns = []

export { render, staticRenderFns }